// a copy of this file exist on backend as well, any change needed to be, should be reflected on both sides.

export function extractPossibleLevel5(mappings) {
    const {v3dqcs_mappings = {}} = mappings;
    return Object.keys(v3dqcs_mappings);
}

export function extractPossibleLevel6(mappings) {
    const {v3dqcos_mappings = {}} = mappings;
    return Object.keys(v3dqcos_mappings);
}

export function extractPossibleLevel8(mappings) {
    const {v3units_mappings = {}} = mappings;
    return Object.keys(v3units_mappings);
}

export function extractPossibleLevel9(mappings) {
    const {v3units_mappings = {}} = mappings;
    const flatted = [].concat(...Object.values(v3units_mappings));
    const set = new Set(flatted)
    return [...set];
}

export function extractPossibleLevel10(mappings) {
    const { v3elements_mappings = {} } = mappings;
    return Object.keys(v3elements_mappings);
}

export function Level5FilterMapping(mappings, v3dqc_no) {
    const {v3dqcs_mappings, v3dqcos_mappings, v3units_mappings, v3elements_mappings} = mappings;
    const filtered_level6 = v3dqcs_mappings[v3dqc_no]?.dqcos ?? [];
    const filtered_level8 = filtered_level6.flatMap(dqco =>
        v3dqcos_mappings[dqco]?.units ?? []
    );
    const filtered_level9 = filtered_level8.flatMap(unit =>
        v3units_mappings[unit] ?? []
    );
    const filtered_level10 = filtered_level9.flatMap(s =>
        Object.values(v3elements_mappings).filter(e => e.session_no === s).map(e => e.element_no)
    );
    return {level6: filtered_level6, level8: filtered_level8, level9: filtered_level9, level10: filtered_level10 };
}

export function Level6FilterMapping(mappings, v3dqco_no) {
    const {v3dqcos_mappings, v3units_mappings, v3elements_mappings} = mappings;
    const filtered_level8 = v3dqcos_mappings[v3dqco_no]?.units ?? [];
    const filtered_level9 = filtered_level8.flatMap(unit =>
        v3units_mappings[unit] ?? []
    );
    const filtered_level10 = filtered_level9.flatMap(s =>
        Object.values(v3elements_mappings).filter(e => e.session_no === s).map(e => e.element_no)
    );
    return {level8: filtered_level8, level9: filtered_level9, level10: filtered_level10 };
}

export function Level8FilterMapping(mappings, v3unit_no) {
    const {v3units_mappings, v3elements_mappings} = mappings;
    const filtered_level9 = v3units_mappings[v3unit_no] ?? [];
    const filtered_level10 = filtered_level9.flatMap(
        s => Object.values(v3elements_mappings).filter(e => e.session_no === s).map(e => e.element_no)
    );
    return {level9: filtered_level9, level10: filtered_level10};
}

export function Level9FilterMapping(mappings, v3session_no) {
    const { v3elements_mappings = {} } = mappings;
    const filtered_level10 = Object.values(v3elements_mappings)
        .filter(e => e.session_no === v3session_no)
        .map(e => e.element_no);
    return { level10: filtered_level10 };
}

// export function Level6BackwardMapping(mappings, level6) {
//     const result = {}
//     const {level5_mappings} = mappings;
//     for(const level5 of Object.keys(level5_mappings)) {
//         if(level5_mappings[level5][level6]) {
//             result.level5 = level5;
//             break;
//         }
//     }
//     return result;
// }

export function Level6BackwardMapping(mappings, level6) {
    const { v3dqcs_mappings = {} } = mappings;     // L5 → { dqcos:[…] }
    for (const [level5, obj] of Object.entries(v3dqcs_mappings)) {
        if (obj.dqcos?.includes(level6)) {
            return { level5 };
        }
    }
    return {};
}

// export function Level8BackwardMapping(mappings, level8) {
//     const result = {}
//     const {level6_mappings} = mappings;
//     //finding level6
//     for(const level6 of Object.keys(level6_mappings)) {
//         if(level6_mappings[level6][level8]) {
//             result.level6 = level6;
//             break;
//         }
//     }
//     //finding level5
//     const {level5} = Level6BackwardMapping(mappings, result.level6);
//     result.level5 = level5;
//     return result;
// }

export function Level8BackwardMapping(mappings, level8) {
    const { v3dqcos_mappings = {} } = mappings;    // L6 → { units:[…] }

    let level6;
    for (const [dqco, obj] of Object.entries(v3dqcos_mappings)) {
        if (obj.units?.includes(level8)) {
            level6 = dqco;
            break;
        }
    }
    if (!level6) return {};                        // not found

    const { level5 } = Level6BackwardMapping(mappings, level6);
    return { level6, level5 };
}

// export function Level9BackwardMapping(mappings, level9) {
//     const result = {}
//     const {level8_mappings} = mappings;
//     //finding level8
//     for(const level8 of Object.keys(level8_mappings)) {
//         if(level8_mappings[level8].includes(level9)) {
//             result.level8 = level8;
//             break;
//         }
//     }
//     //finding level6
//     const {level6} = Level8BackwardMapping(mappings, result.level8);
//     result.level6 = level6;
//     //finding level5
//     const {level5} = Level6BackwardMapping(mappings, result.level6);
//     result.level5 = level5;
//     return result;
// }

export function Level9BackwardMapping(mappings, level9) {
    const { v3units_mappings = {} } = mappings;    // L8 → [ L9, … ]

    let level8;
    for (const [unit, sessions] of Object.entries(v3units_mappings)) {
        if (Array.isArray(sessions) && sessions.includes(level9)) {
            level8 = unit;
            break;
        }
    }
    if (!level8) return {};                        // not found

    const { level6, level5 } = Level8BackwardMapping(mappings, level8);
    return { level8, level6, level5 };
}

// export function Level9ForwardMapping(mappings, level9) {
//     const {level9_mappings = {}} = mappings;
//     return level9_mappings[level9] ? level9_mappings[level9] : {};
// }

export function Level9ForwardMapping(mappings, level9) {
    const { v3sessions_mappings = {}, v3elements_mappings = {} } = mappings;
    const meta = v3sessions_mappings[level9] || {};
    const elem =
        Object.values(v3elements_mappings).find(e => e.session_no === level9) || {};

    return {
        ...meta,
        level10: elem.element_no || '',
        level10_ksab_dimensions: elem.level10_ksab_dimensions || ''
    };
}

export function Level10BackwardMapping(mappings, level10) {
    const { v3elements_mappings = {} } = mappings;

    const item = v3elements_mappings[level10];

    if (!item) return {};

    const v3session_no = item.session_no;
    if (!v3session_no) return {};

    const { level8: v3unit_no, level6: v3dqco_no, level5: v3dqc_no } =
        Level9BackwardMapping(mappings, v3session_no);

    return { v3session_no, v3unit_no, v3dqco_no, v3dqc_no };
}

export function Level10ForwardMapping(mappings, level10) {
    const { v3elements_mappings = {} } = mappings;

    return v3elements_mappings[level10] || {};
}

